import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import Alert from "components/v2/Alert/Alert";
import { ReactComponent as UploadIcon } from "assets/images/iconsV2/upload-cloud-02.svg";
import { ReactComponent as CloseIcon } from "assets/images/iconsV2/x-close.svg";

export default function useGetDocumentParserLabels({ requestType }: { requestType: string }) {
  const navigate = useNavigate();

  function PageTitle() {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="font-bold" style={{ fontSize: "24px" }}>
          {requestType === "quickrequest" ? (
            <FormattedMessage
              id="documentParser.uploadPage.quickRequest.title"
              defaultMessage="Create quick request from document"
            />
          ) : (
            <FormattedMessage
              id="documentParser.uploadPage.quoteRequest.title"
              defaultMessage="Create quote request from document"
            />
          )}
        </div>
        <CloseIcon className="cursor-pointer" onClick={() => navigate("/")} />
      </div>
    );
  }

  function PageSubtitle() {
    return (
      <div className="mb-xl text-secondary mt-xs">
        <FormattedMessage
          id="documentParser.uploadPage.subtitle"
          defaultMessage="Convert your packing list document into a request"
        />
      </div>
    );
  }

  function UploadTitle() {
    return (
      <div className="text-lg font-medium py-xl px-3xl border-bottom-secondary">
        <FormattedMessage
          id="documentParser.uploadPage.uploadYourPackingListDocument"
          defaultMessage="Upload your packing list document"
        />
      </div>
    );
  }

  function UploadTooltips() {
    return (
      <Alert label="" variant="brand">
        <ul>
          <li style={{ listStyleType: "disc" }} className="ml-xl">
            {requestType === "quickrequest" ? (
              <FormattedMessage
                id="documentParser.uploadPage.quickRequest.firstTooltip"
                defaultMessage="Each uploaded document will create its own quick request based on the selected payment location"
              />
            ) : (
              <FormattedMessage
                id="documentParser.uploadPage.quoteRequest.firstTooltip"
                defaultMessage="Each uploaded document will create its own quote request based on the selected payment location"
              />
            )}
          </li>
          <li style={{ listStyleType: "disc" }} className="ml-xl">
            <FormattedMessage
              id="documentParser.uploadPage.secondTooltip"
              defaultMessage="Only one document is allowed per upload"
            />
          </li>
        </ul>
      </Alert>
    );
  }

  function CustomNoResults() {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "320px" }}>
        <div className="upload-dropzone__icon-container">
          <UploadIcon />
        </div>

        <div className="text-secondary-v2 text-md font-semibold">
          <FormattedMessage id="documentParser.uploadPage.table.empty.title" defaultMessage="No documents uploaded yet" />
        </div>

        <div className="text-tertiary text-sm font-regular">
          <FormattedMessage
            id="documentParser.uploadPage.table.empty.subtitle"
            defaultMessage="Upload a document to get started"
          />
        </div>
      </div>
    );
  }

  return { PageTitle, PageSubtitle, UploadTitle, UploadTooltips, CustomNoResults };
}
